/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable react/jsx-props-no-spreading */
import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
// import { selectOSNamesByUserRole } from "../../../redux/selectors/user";
import Member from "../../../services/api/member";
import Dashboard from "./Dashboard/Dashboard";
import MemberDetailCards from "./MemberDetailCards/MemberDetailCards";

import useUserConfig from "../../../hooks/useUserConfig";
import {
  getFormattedAppointments,
  getFormattedData,
  getFormattedMembers,
  getFormattedGohonzon,
  // getFormattedInprogressAppointments,
  getFormattedSubscription,
  getFormattedAllPreviousAppointments,
  getFormattedExam,
  getFormattedAward,
  getFormattedSpecial,
  getFormattedHdc,
} from "./utlis";
import Family from "../../../services/api/Family";
import Loader from "../../../components/common/Loader/Loader";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    margin: "0 -2.65%",
    backgroundColor: "#F7F7F9",
  },
  leftContainer: {
    flex: 1,
    minWidth: 150,
  },
  rightContainer: {
    display: "flex",
    flex: 4,
  },
  tabsStyle: {
    textTransform: "uppercase",
    cursor: "pointer",
    fontSize: "10px",
    font: "normal 600 12px",
    paddingBottom: "8px",
    paddingTop: "8px",
  },
  memberIdStyle: {
    color: "#183053",
    fontWeight: "600",
  },
};

function MembersDetail() {
  const TITLE = "Member Details - BSG";
  const [memberInfo, setMemberInfo] = useState({});
  const [attendanceInfo, setAttendanceInfo] = useState({});
  const [appointmentInfo, setAppointmentInfo] = useState([]);
  const [familyMemberInfo, setFamilyMemebrInfo] = useState([]);
  const [gohonzonMemberInfo, setGohonzonMemberInfo] = useState([]);
  const [previousAppointmentInfo, setPreviousAppointmentInfo] = useState([]);
  const [inProgressAppointmentInfo, setInprogressAppointmentInfo] = useState(
    []
  );
  const [hdcInfo, setHdcInfo] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  // const [isAttendanceLoading, setIsAttendanceLoading] = useState(false);

  const [subscriptionMemberInfo, setSubscriptionMemberInfo] = useState([]);
  const [examMemberInfo, setExamMemberInfo] = useState([]);
  const [awardMemberInfo, setAwardMemberInfo] = useState([]);
  const [specialMemberInfo, setSpecialMemberInfo] = useState([]);
  // const userOSNames = useSelector(selectOSNamesByUserRole);
  // const userOSNames = useSelector(selectOSNamesByUserRole);
  const { id } = useParams();
  const hasPermission = useUserConfig();
  const memberViewId = memberInfo.memberId;

  const handleRemoveItem = () => {
    const updatedItems = familyMemberInfo.filter(
      (item) => item.memberId !== memberViewId
    );

    return updatedItems;
  };

  const updatedFamilyMemberInfo = handleRemoveItem();

  const fetchMemberData = async (memberId) => {
    console.log("LOGGER_HISTORY");
    // try {
    // const promiseAPIs = [
    // Member.memberView(memberId),
    // Member.getAttendanceByMemberId(memberId),
    // Member.getCurrentAppointmentsByMemberId(memberId),
    // Member.getMemberDetailsById(memberId),
    // Member.getAppointmentsByMemberId(memberId),
    // Member.getMemberDetailsById(memberId),
    // Member.getSubscriptionByMemberId(memberId),
    // Member.getExamByMemberId(memberId),
    // Member.getAwardByMemberId(memberId),
    // ];
    // const [
    // memberInfoData,
    // attendanceData,
    // appointmentData,
    // gohonzonData,
    // previousAppointmentData,
    // inprogressAppointmentData,
    // subscriptionData,
    // examData,
    // awardData,
    // ] = await Promise.all(promiseAPIs);

    // Calling Member API
    setIsLoading(true);

    try {
      const memberInfoData = await Member.memberView(memberId);
      setMemberInfo(memberInfoData.data);
      setGohonzonMemberInfo(getFormattedGohonzon(memberInfoData.data));
      setSpecialMemberInfo(
        getFormattedSpecial(memberInfoData.data.inductionSpecialGroups)
      );
      setHdcInfo(getFormattedHdc(memberInfoData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Attendance API
    try {
      console.log("LOGGER_HISTORY_ENTER");
      const attendanceData = await Member.getAttendanceByMemberId(memberId);
      setAttendanceInfo(getFormattedData(attendanceData.data.content));
      console.log("LOGGER_HISTORY", attendanceData);
    } catch (error) {
      console.log("LOGGER_HISTORY_ERROR", error);
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Appointment API
    try {
      const appointmentData = await Member.getCurrentAppointmentsByMemberId(
        memberId
      );
      setAppointmentInfo(
        getFormattedAppointments(appointmentData.data.content)
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Previous API
    try {
      const previousAppointmentData = await Member.getAppointmentsByMemberId(
        memberId
      );
      setPreviousAppointmentInfo(
        getFormattedAllPreviousAppointments(
          previousAppointmentData.data.content
        )
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling InprogressAppointment API
    try {
      const inprogressAppointmentData = await Member.getMemberDetailsById(
        memberId
      );
      setInprogressAppointmentInfo(
        getFormattedAllPreviousAppointments(
          inprogressAppointmentData.data.content
        )
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Subscription API
    try {
      const subscriptionData = await Member.getSubscriptionByMemberId(memberId);
      setSubscriptionMemberInfo(
        getFormattedSubscription(subscriptionData.data)
      );
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Exam API
    try {
      const examData = await Member.getExamByMemberId(memberId);
      setExamMemberInfo(getFormattedExam(examData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Awards API
    try {
      const awardData = await Member.getAwardByMemberId(memberId);
      setAwardMemberInfo(getFormattedAward(awardData.data));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR in Member API", error.message);
    }

    // Calling Family API
    try {
      const familyData = await Family.getFamilyDetailsByMemberId(memberId);
      setFamilyMemebrInfo(getFormattedMembers(familyData?.data?.familyMembers));
    } catch (error) {
      Sentry.captureException("ERROR", error);
      console.log("ERROR", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onRefresh = () => {
    fetchMemberData(memberInfo.memberId);
  };
  useEffect(() => {
    if (id) {
      fetchMemberData(id);
    }
  }, [id]);
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box style={styles.container}>
        <Box style={styles.leftContainer}>
          <MemberDetailCards
            memberInfo={memberInfo}
            hasPermission={hasPermission}
            onRefresh={onRefresh}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
        </Box>
        <Box style={styles.rightContainer}>
          <Dashboard
            memberId={memberInfo.memberId}
            attendanceInfo={attendanceInfo}
            familyMemberInfo={updatedFamilyMemberInfo}
            appointmentInfo={appointmentInfo}
            memberInfo={memberInfo}
            gohonzonMemberInfo={gohonzonMemberInfo}
            previousAppointmentInfo={previousAppointmentInfo}
            inProgressAppointmentInfo={inProgressAppointmentInfo}
            subscriptionMemberInfo={subscriptionMemberInfo}
            examMemberInfo={examMemberInfo}
            awardMemberInfo={awardMemberInfo}
            specialMemberInfo={specialMemberInfo}
            hdcInfo={hdcInfo}
            onRefresh={onRefresh}
          />
        </Box>
      </Box>
      {isLoading && <Loader />}
    </>
  );
}

export default MembersDetail;
